import React from "react";
import { observer } from "mobx-react-lite";
import { TailwindModal } from "./TailwindModal";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useStore } from "../helpers";
import { useTranslation } from "react-i18next";

export const VoterNotFound = observer((props: any) => {
  const { aiGentoolStore } = useStore();
  const { voter_not_found } = aiGentoolStore;
  const {t} = useTranslation("fetchFromFacialRecognition")

  const handleScanAgain = () => {
    aiGentoolStore.show_voter_not_found(false);
    aiGentoolStore.toggle_image_capture_modal(true);
  };

  const handleVoterManually = () => {
    aiGentoolStore.toggle_image_capture_modal(false);
    aiGentoolStore.show_voter_not_found(false);
    aiGentoolStore.toggle_image_match_modal(false);
  };

  return (
    <>
      <TailwindModal isOpen={voter_not_found}>
        <div className="bg-common-white rounded-2xl p-4 max-w-4xl w-full mx-auto h-[85vh] flex flex-col items-center justify-center">
          <DotLottieReact
            src="https://lottie.host/0411860f-0156-42f1-8611-7c8a62fc94f7/MjghhA5fTI.lottie"
            loop
            autoplay
            className={"opacity-75 w-85 h-60"}
          />

          <p className="text-gray-400 text-base font-semibold text-center mb-4 ">
            {t("no_facial")}
            <br />
            {t("you_can_fetch")}
          </p>

          <button
            className="px-8 py-2 rounded-lg border border-[#6D4DFF] text-[#6D4DFF] font-medium
             transition-all duration-300 hover:bg-gradient-to-r hover:from-[#6D4DFF] hover:to-[#3A80F4] hover:text-white"
            onClick={handleVoterManually}
          >
            {t("add_voter_manually")}
          </button>
          <p
            onClick={handleScanAgain}
            className="text-[#7c3aed] underline cursor-pointer hover:text-[#6d28d9] mt-4"
          >
            {t("scan_again")}
          </p>
        </div>
      </TailwindModal>
    </>
  );
});
